import { render } from "./old.vue?vue&type=template&id=653a31d7&scoped=true"
import script from "./old.vue?vue&type=script&lang=js"
export * from "./old.vue?vue&type=script&lang=js"

import "./old.vue?vue&type=style&index=0&id=653a31d7&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653a31d7"]])

export default __exports__